export const percentageIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none">
  <path d="M5,7.5a2.5,2.5 0 1,0 5,0a2.5,2.5 0 1,0 -5,0"/>
  <path d="M14,16.5a2.5,2.5 0 1,0 5,0a2.5,2.5 0 1,0 -5,0"/>
  <path d="M3.75 20.25L20.25 3.75" stroke-linecap="round"/>
  </svg>
  `,
  name: 'percentage',
};
